/* Midnight translation bridge reader (layout/theme.liquid #mw-strings).
   Falls back to the English argument if the bridge is unavailable. Defined
   defensively because several theme scripts share it. */
window.mwString = window.mwString || function (key, fallback) {
  return window.mwT ? window.mwT(key, fallback) : fallback;
};
/* Midnight Search · The Index — header search dialog behaviour.
   - Fills the index (count, maisons, models) from the Available Watches collection, cached for the session.
   - Model shortcuts and the inline field on Available Watches drive the real search input.
   - Below 1180px the sheet follows the visual viewport, so results end above the phone keyboard. */
(function () {
  'use strict';

  var dialog = document.querySelector('[data-mw-search]');
  if (!dialog) return;

  var details = dialog.closest('details');
  var summary = details ? details.querySelector('summary') : null;
  var input = dialog.querySelector('input[type="search"]');
  var CACHE_KEY = 'mw-search-index:v1';
  var CACHE_MS = 10 * 60 * 1000;
  var KEEP_UPPER = { GMT: 1, II: 1, III: 1, IV: 1, IWC: 1, TAG: 1, 'L.U.C': 1 };
  var TWO_WORD_MODELS = {
    'BLACK BAY': 1, 'ROYAL OAK': 1, 'OYSTER PERPETUAL': 1, 'FIFTY FATHOMS': 1, 'BIG PILOT': 1,
    'GMT-MASTER II': 1, 'SEA-DWELLER DEEPSEA': 1, 'PELAGOS FXD': 1, 'SANTOS DE': 1, 'PASHA DE': 1,
    'PORTUGIESER CHRONOGRAPH': 0
  };
  var pending = null;

  function titleCase(value) {
    return String(value).split(/\s+/).filter(Boolean).map(function (word) {
      return word.split('-').map(function (part) {
        var upper = part.toUpperCase();
        if (KEEP_UPPER[upper] || /\d/.test(part)) return upper;
        return upper.charAt(0) + upper.slice(1).toLowerCase();
      }).join('-');
    }).join(' ');
  }

  function modelOf(title, vendor) {
    var text = String(title).toUpperCase().replace(/\s+/g, ' ').trim();
    var brand = String(vendor).toUpperCase().trim();
    if (brand && text.indexOf(brand + ' ') === 0) text = text.slice(brand.length + 1);
    text = text.split(/\s-?\s*REF\b/)[0];
    var words = text.split(' ').filter(function (word) { return word && !/["'“”‘’]/.test(word); });
    if (!words.length || /^\d/.test(words[0])) return '';
    var pair = words.slice(0, 2).join(' ');
    return TWO_WORD_MODELS[pair] ? pair : words[0];
  }

  function summarise(products) {
    var available = products.filter(function (product) {
      return (product.variants || []).some(function (variant) { return variant.available; });
    });
    var vendors = {};
    var models = {};
    available.forEach(function (product) {
      var vendor = String(product.vendor || '').trim();
      if (vendor) vendors[vendor] = (vendors[vendor] || 0) + 1;
      var model = modelOf(product.title, vendor);
      if (model) models[model] = (models[model] || 0) + 1;
    });
    function ranked(map) {
      return Object.keys(map).sort(function (a, b) { return map[b] - map[a] || a.localeCompare(b); });
    }
    return {
      count: available.length,
      maisons: ranked(vendors).slice(0, 5).map(function (vendor) { return { vendor: vendor, label: titleCase(vendor), count: vendors[vendor] }; }),
      models: ranked(models).slice(0, 6).map(function (model) { return { label: titleCase(model), count: models[model] }; })
    };
  }

  function readCache() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      return saved && Date.now() - saved.t < CACHE_MS ? saved.s : null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(value) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), s: value }));
    } catch (error) {
      /* storage unavailable: the index is simply fetched again */
    }
  }

  function loadIndex() {
    if (pending) return pending;
    var cached = readCache();
    if (cached) {
      pending = Promise.resolve(cached);
      return pending;
    }
    pending = fetch(dialog.getAttribute('data-mw-si-feed'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        var value = summarise(data.products || []);
        writeCache(value);
        return value;
      })
      .catch(function () {
        pending = null;
        return null;
      });
    return pending;
  }

  function link(label, href, count, query) {
    var item = document.createElement('li');
    var anchor = document.createElement('a');
    var text = document.createElement('span');
    anchor.className = 'mw-si__link';
    anchor.href = href;
    text.textContent = label;
    anchor.appendChild(text);
    if (count) {
      var number = document.createElement('span');
      number.className = 'mw-si__n';
      number.textContent = count;
      anchor.appendChild(number);
    }
    if (query) anchor.setAttribute('data-mw-si-query', query);
    item.appendChild(anchor);
    return item;
  }

  function renderIndex(value) {
    if (!value || dialog.hasAttribute('data-mw-si-ready')) return;
    var available = dialog.getAttribute('data-mw-si-available');
    var searchUrl = dialog.getAttribute('data-mw-si-search');
    var count = dialog.querySelector('[data-mw-si-count]');
    var maisons = dialog.querySelector('[data-mw-si-maisons]');
    var models = dialog.querySelector('[data-mw-si-models]');
    if (count) count.textContent = value.count;
    if (maisons) {
      maisons.textContent = '';
      value.maisons.forEach(function (maison) {
        var params = new URLSearchParams();
        params.set('filter.p.vendor', maison.vendor);
        params.set('filter.v.availability', '1');
        maisons.appendChild(link(maison.label, available + '?' + params.toString(), maison.count));
      });
    }
    if (models) {
      models.textContent = '';
      value.models.forEach(function (model) {
        var params = new URLSearchParams();
        params.set('q', model.label);
        params.set('options[prefix]', 'last');
        models.appendChild(link(model.label, searchUrl + '?' + params.toString(), 0, model.label));
      });
    }
    dialog.setAttribute('data-mw-si-ready', '');
  }

  function prewarm() {
    loadIndex().then(renderIndex);
  }

  /* Visual viewport: the sheet ends where the keyboard begins. */
  var viewport = window.visualViewport;
  function syncViewport() {
    if (!viewport) return;
    dialog.style.setProperty('--mw-si-vh', viewport.height + 'px');
    dialog.style.setProperty('--mw-si-top', viewport.offsetTop + 'px');
  }

  function onToggle() {
    if (details.open) {
      prewarm();
      syncViewport();
      if (viewport) {
        viewport.addEventListener('resize', syncViewport);
        viewport.addEventListener('scroll', syncViewport);
      }
    } else if (viewport) {
      viewport.removeEventListener('resize', syncViewport);
      viewport.removeEventListener('scroll', syncViewport);
      dialog.style.removeProperty('--mw-si-vh');
      dialog.style.removeProperty('--mw-si-top');
    }
  }

  /* The full sentence fits the desktop field; phones get the short form so it is never cut off. */
  if (input && window.matchMedia) {
    var narrow = window.matchMedia('(max-width: 1179px)');
    var setPlaceholder = function () {
      input.placeholder = narrow.matches ? mwString('search.placeholder_short', 'Brand, model or reference') : mwString('search.placeholder', 'Search by brand, model or reference');
    };
    setPlaceholder();
    if (narrow.addEventListener) narrow.addEventListener('change', setPlaceholder);
  }

  if (details) details.addEventListener('toggle', onToggle);
  if (summary) {
    summary.addEventListener('pointerenter', prewarm, { once: true });
    summary.addEventListener('focus', prewarm, { once: true });
    summary.addEventListener('touchstart', prewarm, { once: true, passive: true });
  }

  /* Model shortcuts search in place. */
  dialog.addEventListener('click', function (event) {
    var shortcut = event.target.closest('[data-mw-si-query]');
    if (!shortcut || !input) return;
    event.preventDefault();
    input.value = shortcut.getAttribute('data-mw-si-query');
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  /* Keep Tab inside the dialog. Dawn's trap is measured when the dialog opens, before the index and the
     results exist, so its last element goes stale. Result rows use tabindex="-1" (combobox pattern). */
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !details || !details.open) return;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'),
      function (element) { return element.tabIndex >= 0 && element.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var inside = focusable.indexOf(document.activeElement) !== -1;
    if (event.shiftKey && (document.activeElement === first || !inside)) {
      event.preventDefault();
      event.stopPropagation();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !inside)) {
      event.preventDefault();
      event.stopPropagation();
      first.focus();
    }
  });

  /* Inline entry points (Available Watches) open the header search within the same tap. */
  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest('[data-mw-open-search]')) prewarm();
  });
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mw-open-search]');
    if (!opener || !summary) return;
    event.preventDefault();
    event.stopPropagation();
    if (!details.open) summary.click();
    if (input) input.focus();
  });
})();
